/*
 * @Author: ly /home card Json
 * @Date: 2020-12-21 15:16:50
 * @LastEditTime: 2021-01-08 16:29:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zcjb\src\components\ebs_card\Json.js
 */
import store from '@/store/index'

export const data = [
  {
    path: '/guaranteeBankView',
    img: require('@/assets/bg_danbao@3x.png'),
    Title: '电子担保保函',
    asideTitle:
      '由担保机构出具的保证投标人不得撤销投标文件、中标后不得无正当理由不与招标人订立合同等的书面担保承诺。',
    detailList: [
      {
        title: '适合对象',
        explain: '投标企业',
      },
      {
        title: '产品优势',
        explain: '资料简单、免保证金、在线验真',
      },
      {
        title: '出函机构',
        explain: '担保机构',
      },
      {
        title: '办理流程',
        explain: '填写申请信息-签订协议-支付-出函',
      },
      {
        title: '办理时效',
        explain: '5分钟',
      },
    ],
    disable:store.state.letter.isCqsw
  },
  {
    img: require('@/assets/bg_yinhang@3x.png'),
    path: '/applyBankMain',
    Title: '银行保函',
    asideTitle:
      '由银行出具的保证投标人不得撤销投标文件、中标后不得无正当理由不与招标人订立合同等的书面担保承诺。',
    detailList: [
      {
        title: '适合对象',
        explain: '投标企业',
      },
      {
        title: '产品优势',
        explain: '操作简便、免保证金、费用低',
      },
      {
        title: '出函机构',
        explain: '银行',
      },
      {
        title: '办理流程',
        explain: '填写申请信息-支付-出函',
      },
      {
        title: '办理时效',
        explain: '当天',
      },
    ],
    disable:store.state.letter.isCqsw
  },
  {
    img: require('@/assets/bg_baoxian@3x.png'),
    path: '/applyInsurance',
    Title: '保险保函',
    asideTitle:
      '由保险公司出具的保证投标人不得撤销投标文件、中标后不得无正当理由不与招标人订立合同等的书面担保承诺。',
    detailList: [
      {
        title: '适合对象',
        explain: '投标企业',
      },
      {
        title: '产品优势',
        explain: '操作简便、免保证金',
      },
      {
        title: '出函机构',
        explain: '保险公司',
      },
      {
        title: '办理流程',
        explain: '填写申请信息-支付-出函',
      },
      {
        title: '办理时效',
        explain: '当天',
      },
    ],
    disable:store.state.letter.isCqsw
  },
  {
    img: require('@/assets/bg_lvyue@3x.png'),
    path: '/applicationPerformance',
    Title: '履约保函',
    asideTitle:
      '应中标人的请求，金融机构/担保机构向业主方做出的一种履约保证承诺。',
    detailList: [
      {
        title: '适合对象',
        explain: '中标企业',
      },
      {
        title: '产品优势',
        explain: '资料简单、免保证金、担保额度大',
      },
      {
        title: '出函机构',
        explain: '银行、担保机构',
      },
      {
        title: '办理流程',
        explain: '申请-递交材料-线下支付-线下出函',
      },
      {
        title: '办理时效',
        explain: '担保当天，银行2~3个工作日',
      },
    ],
    disable:store.state.letter.isCqsw
  },
]

export const data2 = {
  leftImg: require('@/assets/home/card_nor/baohandaikuan.png'),
  item: [
    {
      icon: require('@/assets/home/card_nor/yufukuan.png'),
      title: '预付款保函',
      text:
        '保证业主给予供应商预付款后，一旦供应商未能履约，银行/担保机构将在收到业务的索赔后向业务返还该预付款的书面承诺。',
    },
    {
      icon: require('@/assets/home/card_nor/zhiliangjishu.png'),
      title: '质量保函',
      text: '如货物或者工程的质量不符合合同的约定，予以赔偿的保函',
    },
    {
      icon: require('@/assets/home/card_nor/nongmingong.png'),
      title: '农民工工资保函',
      text: '对业主或者承包商支付民工工资义务的担保保函',
    },
    {
      icon: require('@/assets/home/card_nor/xingyongbaogao.png'),
      title: '信用报告',
      text: '为投标人生成专业企业信用评价报告',
    },
    {
      icon: require('@/assets/home/card_nor/toubiaodai.png'),
      title: '投标贷',
      text: '仅限项目投标过程中资金需求的专项授信',
    },
    {
      icon: require('@/assets/home/card_nor/zhongbiaodai.png'),
      title: '中标贷',
      text: '为项目承包方中标后筹集采购或者施工所需要资金提供的专项贷款',
    },
    {
      icon: require('@/assets/home/card_nor/kaigongdai.png'),
      title: '开工贷',
      text:
        '为项目承包方项目中标后，开工前期采购或进场施工所需资金，提供专项贷款',
    },
    {
      icon: require('@/assets/home/card_nor/jindudai.png'),
      title: '进度贷',
      text: '为项目承包方中标后。前期采购或进场施工所需要的资金，提供专项贷款',
    },
  ],
}

export const friendList = [
  {
    logo: require('@/assets/home/friends/6@3x.png'),
    title: '建设银行',
  },
  {
    logo: require('@/assets/home/friends/4@3x.png'),
    title: '华商银行',
  },
  {
    logo: require('@/assets/home/friends/5@3x.png'),
    title: '重庆富民银行',
  },
  {
    logo: require('@/assets/home/friends/1@3x.png'),
    title: '中华保险',
  },
  {
    logo: require('@/assets/home/friends/13@3x.png'),
    title: '广西中小担保',
  },
  {
    logo: require('@/assets/home/friends/2@3x.png'),
    title: '正泓担保',
  },
  {
    logo: require('@/assets/home/friends/14@3x.png'),
    title: '诚信达担保',
  },
  // {
  //   logo: require('@/assets/home/friends/8@3x.png'),
  //   title: '河北创资担保',
  // },
  // {
  //   logo: require('@/assets/home/friends/9@3x.png'),
  //   title: '河北众信成',
  // },
  {
    logo: require('@/assets/home/friends/10@3x.png'),
    title: '华商担保',
  },
  {
    logo: require('@/assets/home/friends/15@3x.png'),
    title: '阳光保险集团',
  },
  {
    logo: require('@/assets/home/friends/16@3x.png'),
    title: '银宏担保',
  },
]
